import { useState } from 'react'
import { Avatar } from '@applift/factor'

interface MeasurementPartnerAvatarProps {
  logoUrl?: string
  name?: string
}

export const MeasurementPartnerAvatar = (
  props: MeasurementPartnerAvatarProps
) => {
  const { logoUrl, name } = props
  const [hasError, setHasError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  return (
    <Avatar
      size="exSmall"
      src={logoUrl}
      alt={name}
      sx={{
        bgColor: hasError || isLoading || !logoUrl ? 'primary-500' : 'inherit',
      }}
      imgProps={{
        onError: () => setHasError(true),
        onLoad: () => setIsLoading(false),
        style: { objectFit: 'cover' },
      }}
    />
  )
}
